import { HTMLAttributes } from 'react'

const SkeletonRounded = {
  'none': 'none',
  '2xs': '2xs',
  'xs': 'xs',
  'sm': 'sm',
  'md': 'md',
  'lg': 'lg',
  'xl': 'xl',
  '2xl': '2xl',
  'max': 'max',
}

export namespace SkeletonProps {
  export type Rounded = keyof typeof SkeletonRounded

  export interface Component extends HTMLAttributes<HTMLDivElement> {
    /** Largura do skeleton em pixels */
    width?: number

    /** Altura do skeleton em pixels */
    height?: number

    /** Arredondamento do skeleton */
    rounded?: Rounded

    /** Classe CSS */
    className?: string

    /** Elemento filho a ser exibido (SEO) */
    children?: JSX.Element
  }
}

export const SkeletonValues = {
  Default: {
    Height: 100,
    Rounded: 'none',
  },
  List: {
    /** Arredondamentos do skeleton */
    Rounded: Object.values(SkeletonRounded),
  },
}
